module.exports = __webpack_public_path__ + "static/media/previous_paper_analysis.2e80fcea.png";